
import { useNavigate } from "react-router-dom";
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow, } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useProveedoresStore } from "../../../stores/productos/proveedores";
import { deleteProveedor } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";


import Swal from "sweetalert2";
const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaProveedores = ({ data, chagePage, page }) => {


    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { totalProveedores } = useProveedoresStore();


    const handleActualizarProveedor = (id) => {
        navigate(`/super/crear-proveedor/${id}`);
    }



    const eliminarProveedor = async(p) => {
        const result = await Swal.fire({
            title: 'Eliminar Proveedor',
            text: `¿Está seguro de eliminar a ${p.nombre}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
        });

        if (result.isConfirmed) {
            await deleteProveedor(p.id);
            queryClient.invalidateQueries({ queryKey: ['proveedor-todos'] });
        }
    }



    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalProveedores / +paginado)} disabled={Math.ceil(totalProveedores / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'30%'}}>Nombre</TableCell>
                        <TableCell sx={{width:'20%'}}>Movil</TableCell>
                        <TableCell sx={{width:'15%'}}>Pago</TableCell>
                        <TableCell sx={{width:'15%'}}>Ciudad</TableCell>
                        <TableCell sx={{width:'15%'}}>Opciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (p) => (
                    <TableRow key={ p.id }  sx={{cursor:'pointer'}}>
                        <TableCell>{ p.nombre }</TableCell>
                        <TableCell>{ p.movil }</TableCell>
                        <TableCell>{ p.formaPago }</TableCell>
                        <TableCell>{ p.ciudad }</TableCell>
                        <TableCell>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <TooltipAndIcon
                                    titulo="Editar Proveedor"
                                    icono="editar"
                                    color="white"
                                    onClick={ () => handleActualizarProveedor(p.id) }
                                />
                                
                                <TooltipAndIcon
                                    titulo="Eliminar Proveedor"
                                    icono="eliminar"
                                    color="red"
                                    onClick={ () => eliminarProveedor(p) }
                                /> 
                            </Stack>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        :    <MensajeAlertaDanger titulo='No hay proveedores disponibles' />
        }
        </>

    )
}
